module.exports = {
  dimensions: {
    width: 35,
    height: 35
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};